import { render, staticRenderFns } from "./UberCategories.vue?vue&type=template&id=4187adce"
import script from "./UberCategories.vue?vue&type=script&lang=js"
export * from "./UberCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports